// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__3c6bH","text":"style_text__1xpqi","defaultColorsList":"style_defaultColorsList__2x05m","defaultColor":"style_defaultColor__20SHv"};